export const tr = {
    'active-status': 'Aktif',
    'age-limit': 'Bilgi hizmetleri yaş sınırı',
    'archived-status': 'Arşivde',
    'audio-creatives': 'Sesli kreatifler',
    'banner-adaptive-image': 'Uyarlanabilir',
    'banner-body': 'Hizmet veya ürün reklamınızın metni.',
    'banner-domain': 'web sitesi adresi',
    'banner-href-choose-protocol': 'Protokol seçin',
    'banner-href-domain-invalid': 'Alan adı formatı hatalı',
    'banner-href-http-invalid': 'Sunucunuz hata verdi: 404 Not Found',
    'banner-href-http-timeout': 'Sunucunuz hata verdi: 400 unavailable',
    'banner-href-invalid': 'Bağlantı formatı yanlış',
    'banner-href-null': 'Bağlantı boş bırakılamaz',
    'banner-price': 'Reklamlarda fiyatlar',
    'banner-title': 'Reklam başlığı',
    'banner-type-content-promotion-collection': 'Yandex Koleksiyon promosyonu',
    'banner-type-content-promotion-video': 'Yandex Video promosyonu',
    'banner-type-cpc_video': 'Video',
    'banner-type-cpm-indoor': 'İç mekan reklamları',
    'banner-type-cpm_audio': 'Ses',
    'banner-type-cpm_banner': "Medya banner'ı",
    'banner-type-cpm_geoproduct': "Yandex.Metro banner'ı",
    'banner-type-cpm_geoproduct-new': 'Konum bazlı alanlarda banner',
    'banner-type-cpm_outdoor': 'Dış mekan reklamı',
    'banner-type-cpm_video': 'Medya videosu\r',
    'banner-type-dynamic': 'Dinamik reklam',
    'banner-type-image_ad': 'Grafik reklam',
    'banner-type-internal': 'Internal türü reklam',
    'banner-type-internal-autobudget': 'Otomatik bütçeli kampanya',
    'banner-type-internal-distrib': 'Dağıtım reklamı',
    'banner-type-internal-free': 'Ücretsiz reklam',
    'banner-type-mcbanner': "Arama banner'ı",
    'banner-type-mobile_content': 'Mobil uygulama reklamı',
    'banner-type-performance': 'Akıllı banner',
    'banner-type-text': 'Metin-grafik reklam',
    'banner-type-text-mobile': 'Mobil metin-grafik reklam',
    callouts: 'Netleştirmeler',
    'callouts-resource-name': 'netleştirmeler',
    'callouts-resource-rejected': 'Netleştirmeler moderasyonda reddedildi',
    'child-age-limit': 'Bebek maması için yaş sınırı',
    'choose-creatives-presets': 'Daha önce oluşturulanlardan seç',
    'choose-gallery': 'Daha önce indirilenlerden seç',
    contactPerson: 'Müşteri',
    counters: 'Gösterim sayacı',
    'cpm-image-creative': 'Kreatifler',
    'created-creatives': 'Hazır kreatifler',
    'creative-help':
        "{constructor}'da kendi kreatifinizi oluşturun veya {requirements} ile uyumlu hazır bir kreatif ekleyin",
    'creative-help-mc-banner': '{requirements} ile uyumlu hazır kreatif ekleyin',
    creatives: 'Kreatifler',
    'creatives-constructor': 'Kreatif Sihirbazı',
    'creatives-ideas': 'Kreatif fikirleri',
    'creatives-resource-name': 'kreatifler',
    'creatives-resource-rejected': 'Kreatifler moderasyonda reddedildi',
    default: 'Seç',
    'display-href-resource-name': 'gösterilen bağlantı',
    'display-href-resource-rejected': 'Gösterilen bağlantı moderasyonda reddedildi',
    'draft-status': 'Taslak',
    icq: 'ICQ',
    'image-creative': 'Grafik kreatifler',
    images: 'Görseller',
    'images-resource-name': 'görsel',
    'images-resource-rejected': 'Görsel moderasyonda reddedildi',
    'in-constructor': 'Sihirbaz',
    'is-previous-version-shown': 'Önceki sürümün gösterimleri devam ediyor',
    'is-rejected-on-moderation': 'Moderasyonda reddedildi',
    jabber: 'Jabber/GTalk',
    link: 'Bağlantının tamamını değiştir',
    'link-groups-mass-action': 'Bağlantıları değiştir',
    'link-replace': 'Bağlantının parçası',
    'link-title': 'Site veya sosyal ağ bağlantısı',
    mailru: 'MailRu Agent',
    'manually-suspended-status': 'Durduruldu',
    'moderation-rejected-status': 'Moderasyonda reddedildi',
    'moderation-status': 'Moderasyonda',
    'not-grouped-mass-action': 'Kalan her şey',
    'on-video-creative-close': 'Kaydedilmeyen değişiklikler silinecek. Devam edilsin mi?',
    'organization-title': "Yandex.Rehber'deki kurum",
    pixel: 'Yandex.Audience pikseli',
    'placement-pages-rejected': 'Uygun panolar seçilmedi',
    'preset-adaptive': 'Uyarlanabilir şablon',
    'preset-create-new': 'Yenisini oluştur',
    price: 'Reklamdaki fiyat',
    'rejected-on-moderation-resources': 'Moderasyonda reddedildi: {resources}',
    requirements: 'Koşullar',
    'site-links': 'Hızlı bağlantılar',
    sitelink: 'Hızlı bağlantı',
    'sitelinks-resource-name': 'hızlı bağlantılar',
    'sitelinks-resource-rejected': 'Hızlı bağlantılar moderasyonda reddedildi',
    skype: 'Skype',
    'standard-image': 'Standart görsel',
    telegram: 'Telegram',
    'temporarly-suspended-status': 'Gözetim tarafından durduruldu',
    'text-groups-mass-action': 'Reklamlarda metin',
    'text-path-replace': 'Bul ve değiştir',
    tracking: 'İzleme parametreleri',
    turbo: 'Turbo sayfalar',
    'turbo-gallery': "Turbo Galeri'de gösterimler",
    'turbo-title': 'Turbo sayfa',
    turbolanding: 'Turbo sayfa',
    'turbolandings-resource-name': 'Turbo sayfa',
    'turbolandings-resource-rejected': 'Turbo sayfa moderasyonda reddedildi',
    'upload-link': 'Bağlantıdan yükle',
    'upload-local': 'Bilgisayardan yükle',
    'vcard-resource-name': 'iletişim bilgileri',
    'vcard-resource-rejected': 'İletişim bilgileri moderasyonda reddedildi',
    'vcard-title': 'Sanal kartvizit',
    viber: 'Viber',
    video: 'Video eklentiler',
    'video-addition': 'Video eklentisi',
    'video-addtions-resource-name': 'video eklentisi',
    'video-addtions-resource-rejected': 'Video eklentisi moderasyonda reddedildi',
    'video-body-placeholder': 'Video açıklaması',
    'video-creatives': 'Video kreatifler',
    'video-title-placeholder': 'Video başlığı',
    'visible-domain': 'Alan adı',
    'visible-link-replace': 'Gösterilen bağlantılar',
    whatsapp: 'Whatsapp',
    'wide-image': 'Geniş ekran görseli',
    'yandex-collections': 'Yandex.Koleksiyonlar',
    'yandex-video': 'Yandex.Video'
};
